module.exports = __webpack_public_path__ + "static/media/personal-drinks-2.ad17ee4b.jpg";